/**
 * 産廃回収詳細 運搬先事業場編集
 */
import Vue from 'vue'
import * as httpConst from '../../../../../../constants/httpConst'

const API_PATH = `${httpConst.DRIVER_ENDPOINT}/manifest/managements`

const manifest_management_verify_transport_location = {
  namespaced: true,
  actions: {
    /**
     * 変更確認
     * @param commit
     * @param id { number }
     * @param params { Object }
     * @return {Promise<unknown>}
     */
    update ({ commit }, { id, params }) {
      return new Promise( ( resolve ) => {
        const api_path = `${API_PATH}/verifies/${id}/transport_locations`
        Vue.$http.put(api_path, params).then( data => {
          let content = data.content
          resolve(content)
        } )
      })
    },
  },
}
export default manifest_management_verify_transport_location
